webpackJsonp([4],{

/***/ 100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v("\n      Please use the menu at the top of the page to continue browsing\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "image-container"
  }, [_c('ImageLoader', {
    staticClass: "image",
    attrs: {
      "src": _vm.randomImage,
      "lazy": "true"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("\n      A delicious creation that has finished baking\n    ")])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "wrapper not-found__blog-post-container"
  }, [_c('div', {
    staticClass: "not-found__while-you-wait-title"
  }, [_vm._v("While you wait, have a read of my latest blog post")]), _vm._v(" "), _c('div', {
    staticClass: "not-found__blog-post"
  }, [_vm._v("\n      Either embed the latest blog post here, or just show the excerpt, and the user can then click on Read More, to\n      be taken through to the blog posts page\n    ")])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('p', [_vm._v("Or use the menu at the top to navigate to a page that is ready")]), _vm._v(" "), _c('ul', {
    staticClass: "not-found__menu"
  }, [_vm._l((_vm.$store.state.routerLinks), function(link, index) {
    return [_c('li', {
      staticClass: "nav-link"
    }, [_c('router-link', {
      attrs: {
        "to": link.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(link.label))])], 1)]
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Oops, this page hasn't been baked yet!")])])
}]}

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('ul', {
    staticClass: "menu-links"
  }, [_c('li', {
    staticClass: "menu-button",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('span', {
    staticClass: "menu-button-text"
  }, [_vm._v("Menu")])]), _vm._v(" "), _vm._l((_vm.$store.state.routerLinks), function(link, index) {
    return [_c('li', {
      staticClass: "nav-link"
    }, [_c('router-link', {
      staticClass: "no-style",
      attrs: {
        "to": link.path,
        "exact": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggleMobileMenu($event)
        }
      }
    }, [_vm._v(_vm._s(link.label))])], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_Full__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_containers_Full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_containers_Full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_NotFound__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_containers_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_containers_NotFound__);






var Home = function Home() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 112));
};
var Gallery = function Gallery() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 111));
};

var Contact = function Contact() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 110));
};


__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/home',
    name: 'app',
    component: __WEBPACK_IMPORTED_MODULE_2_containers_Full___default.a,
    children: [{
      path: 'home',
      name: 'home',
      component: Home
    }, {
      path: 'gallery',
      name: 'gallery',
      component: Gallery
    }, {
      path: 'contact',
      name: 'contact',
      component: Contact
    }]
  }, {
    path: '*',
    name: 'notFound',
    redirect: '/notFound',
    component: __WEBPACK_IMPORTED_MODULE_2_containers_Full___default.a,
    children: [{
      path: 'notFound',
      name: 'notFound404',
      component: __WEBPACK_IMPORTED_MODULE_3_containers_NotFound___default.a
    }]
  }]
}));

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__application_config__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__application_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__application_config__);







__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    stateLoaded: false,
    galleryImageData: [],
    highResolution: false,
    canUseWebP: false,
    randomImages: {
      one: '',
      two: '',
      three: ''
    },
    routerLinks: [{
      'path': '/',
      'label': 'Home'
    }, {
      'path': '/gallery',
      'label': 'Gallery'
    }, {
      'path': '/contact',
      'label': 'Contact'
    }]
  },

  mutations: {
    setStateLoaded: function setStateLoaded(state, isSet) {
      state.stateLoaded = isSet;
    },
    storeGalleryImageData: function storeGalleryImageData(state, galleryImages) {
      state.galleryImageData = galleryImages;
    },
    setRandomImage: function setRandomImage(state, _ref) {
      var randomImage = _ref.randomImage,
          imageId = _ref.imageId;

      switch (randomImage) {
        case 1:
          state.randomImages.one = state.galleryImageData[imageId];
          break;

        case 2:
          state.randomImages.two = state.galleryImageData[imageId];
          break;

        case 3:
          state.randomImages.three = state.galleryImageData[imageId];
          break;
      }
    },
    setHighResolution: function setHighResolution(state, highResolution) {
      state.highResolution = highResolution;
    },
    canUseWebP: function canUseWebP(state, _canUseWebP) {
      state.canUseWebP = _canUseWebP;
    }
  },

  actions: {
    loadState: function loadState(_ref2) {
      var _this = this;

      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var imagesJson, images, query;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_vue___default.a.http.get(__WEBPACK_IMPORTED_MODULE_5__application_config___default.a.cloudFunctionsUrl + '/getAllImages');

              case 2:
                imagesJson = _context.sent;
                _context.next = 5;
                return imagesJson.json();

              case 5:
                images = _context.sent;


                commit('storeGalleryImageData', images);
                commit('setStateLoaded', true);
                dispatch('randomizeImages');

                query = '(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)';

                if (matchMedia(query).matches) {
                  commit('setHighResolution', true);
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    randomizeImages: function randomizeImages(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var selectedIds = [];

      if (!state.stateLoaded) {
        return null;
      }

      var randomImage = function randomImage() {
        var id = Math.floor(Math.random() * state.galleryImageData.length);

        if (selectedIds.indexOf(id) >= 0 || state.galleryImageData[id].isFeaturable === '0') {
          return randomImage();
        }

        selectedIds.push(id);
        return id;
      };

      commit('setRandomImage', { randomImage: 1, imageId: randomImage() });
      commit('setRandomImage', { randomImage: 2, imageId: randomImage() });
      commit('setRandomImage', { randomImage: 3, imageId: randomImage() });
    }
  },

  getters: {
    canUseWebP: function canUseWebP(state) {
      return state.canUseWebP;
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(87)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(97),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

const isLive = window.location.hostname !== 'localhost';

module.exports = {
  cloudFunctionsUrl: isLive ? 'https://us-central1-bekbakes-1111.cloudfunctions.net' : 'http://localhost:5001/bekbakes-1111/us-central1',
  firebase: {
    apiKey: 'AIzaSyDi0y4_Ih0hlVe3sBuutT3jLh0MK0MWaKk',
    authDomain: 'bekbakes-1111.firebaseapp.com',
    databaseURL: 'https://bekbakes-1111.firebaseio.com/',
    projectId: 'bekbakes-1111',
    storageBucket: 'bekbakes-1111.appspot.com'
  }
}


/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Store__ = __webpack_require__(38);






__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function () {
  window.scrollTo(0, 0);
});

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  store: __WEBPACK_IMPORTED_MODULE_3__services_Store__["a" /* store */],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a },
  mounted: function mounted() {
    this.$store.dispatch('loadState');
  }
});

window.prerenderReady = true;

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PictureLoader__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PictureLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PictureLoader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__Navbar___default.a,
    PictureLoader: __WEBPACK_IMPORTED_MODULE_1__PictureLoader___default.a
  },
  methods: {
    click: function click() {}
  }
});

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ImageLoader',
  props: ['src', 'lazy', 'alt'],

  mounted: function mounted() {
    var _this = this;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || _this.hasIntersected) return;

      _this.hasIntersected = true;
    });

    this.$el.addEventListener('load', function (e) {
      e.target.classList.add('loaded');
    });

    observer.observe(this.$el);
  },

  computed: {
    image: function image() {
      return this.hasIntersected ? this.$store.getters.canUseWebP ? this.src + '.webp' : this.src : '';
    }
  },

  data: function data() {
    return {
      hasIntersected: false
    };
  },
  methods: {}
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Navbar',
  components: {},
  data: function data() {
    return {};
  },
  methods: {
    toggleMobileMenu: function toggleMobileMenu() {
      if (window.innerWidth <= 719) {
        this.$el.classList.toggle('show');
        document.querySelector('body').classList.toggle('no-scroll');
      }
    }
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PictureLoader',

  props: ['src', 'lazy', 'alt'],

  components: {},

  mounted: function mounted() {
    var _this = this;

    if (this.lazy === 'true' && document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        _this.load = true;
      });
    } else {
      this.load = true;
    }
  },

  computed: {
    image: function image() {
      return this.src;
    },
    smallImage: function smallImage() {
      return this.src.replace(/(\.(png|jpg|gif|jpeg))$/, '_small$1');
    }
  },

  data: function data() {
    return {
      load: false
    };
  },

  methods: {}
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Header__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_Header___default.a
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageLoader__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImageLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ImageLoader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NotFound',
  components: {
    ImageLoader: __WEBPACK_IMPORTED_MODULE_0__components_ImageLoader___default.a
  },
  computed: {
    randomImage: function randomImage() {
      if (typeof this.$store.state.randomImages.one.paths !== 'undefined') {
        return this.$store.state.randomImages.one.paths.medium;
      }

      return '';
    }
  },
  data: function data() {
    return {};
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch('randomizeImages');
  },
  methods: {}
});

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(96),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "site-header"
  }, [_c('Navbar'), _vm._v(" "), _c('div', {
    staticClass: "logo-container"
  }, [_c('router-link', {
    staticClass: "no-style",
    attrs: {
      "to": '/',
      "exact": ""
    }
  }, [_c('PictureLoader', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo.png",
      "lazy": "false"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['app', this.name]
  }, [_c('AppHeader'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('picture', [_c('source', {
    attrs: {
      "srcset": _vm.smallImage,
      "media": "(max-width: 697px)"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.image,
      "alt": _vm.alt
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ })

},[47]);


// WEBPACK FOOTER //
// static/js/app.5d32970ca29e46e1590f.js